<div class="container my-5">
  <div class="card shadow-sm border-0 rounded-4 p-5 text-center">
    <div *ngIf="flag; else rememberPassword">
      <!-- Lista de pasos -->
      <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
        <i class="fa fa fa-sign-out"></i>
        {{ 'autenticacion-digital.titulo-crear' | translate }}
      </h4>
      <h6 class="wrapper__form__title h3-tipografia-govco my-1">
        {{ 'autenticacion-digital.subtitulo' | translate }}</h6>
      <div class="steps-list mx-auto" style="max-width: 500px;" *ngIf="textoPasosCreacion">
        <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
          <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
            1
          </div>
          <div class="step-text">
            <p class="mb-0">
              {{textoPasosCreacion.data.registros[0].valor_parametro}}
            </p>
          </div>
        </div>

        <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
          <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
            2
          </div>
          <div class="step-text">
            <p class="mb-0">
              {{textoPasosCreacion.data.registros[1].valor_parametro}}
            </p>
          </div>
        </div>


        <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
          <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
            3
          </div>
          <div class="step-text">
            <p class="mb-0">
              {{textoPasosCreacion.data.registros[2].valor_parametro}}
            </p>
          </div>
        </div>

        <div class="step-item bg-warning-subtle p-3 rounded-3 mb-3 d-flex">
          <div class="step-number bg-warning text-white rounded-circle flex-shrink-0">
            i
          </div>
          <div class="step-text">
            <p class="mb-0">
              {{textoPasosCreacion.data.registros[3].valor_parametro}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-template #rememberPassword>
      <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
        <i class="fa fa fa-sign-out"></i>
        {{ 'autenticacion-digital.titulo-password' | translate }}
      </h4>
      <h6 class="wrapper__form__title h3-tipografia-govco my-1">
        {{ 'autenticacion-digital.subtitulo' | translate }}</h6>
      <div class="steps-list mx-auto" style="max-width: 500px;">
        <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
          <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
            1
          </div>
          <div class="step-text">
            <p class="mb-0">
              {{ 'autenticacion-digital.pasos-password.paso1' | translate }}
            </p>
          </div>
        </div>

        <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
          <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
            2
          </div>
          <div class="step-text">
            <p class="mb-0">
              {{ 'autenticacion-digital.pasos-password.paso2' | translate }}
            </p>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="mt-4 d-flex justify-content-center align-items-center" style="max-height: 100px;">
      <button class="btn-govco fill-btn-govco
        px-4 py-1 rounded-pill fw-semibold
        d-flex align-items-center" type="button" (click)="redirectToCarpetaCiudadanaDigital()"
        title="{{ 'autenticacion-digital.boton' | translate }}"
        aria-label="Ir a Carpeta Ciudadana Digital">
        <i class="fa fa-arrow-right me-2" aria-hidden="true"></i>
        {{ 'autenticacion-digital.boton' | translate }}
      </button>
    </div>
    <div class="mt-4 d-flex justify-content-center align-items-center" style="max-height: 100px;">
      <button *ngIf="flag; else rememberPasswordPyme" class="btn-govco fill-btn-govco
        px-4 py-1 rounded-pill fw-semibold
        d-flex align-items-center" type="button" (click)="redirectToFormEmpresa()"
        title="{{ 'autenticacion-digital.boton-empresa' | translate }}"
        aria-label="Ir a formulario de empresa">
        <i class="fa fa-arrow-right me-2" aria-hidden="true"></i>
        {{ 'autenticacion-digital.boton-empresa' | translate }}
      </button>
      <ng-template #rememberPasswordPyme>
        <button class="btn-govco fill-btn-govco
          px-4 py-1 rounded-pill fw-semibold
          d-flex align-items-center" type="button"
          title="{{ 'autenticacion-digital.boton' | translate }}"
          (click)="openModalContrasenia()"
          aria-label="Recuperar contraseña empresa">
          <i class="fa fa-arrow-right me-2" aria-hidden="true"></i>
          {{ 'autenticacion-digital.boton-recuperar-password-empresa' | translate }}
        </button>
      </ng-template>


    </div>
    <!-- Footer -->
    <!-- Se comenta el correo, de acuerdo con el bug # 5765-->
<!--    <div class="mt-4 text-muted small">-->
<!--      <i class="bi bi-envelope"></i> {{ 'autenticacion-digital.correoAyuda' | translate }}-->
<!--    </div>-->
  </div>
</div>

<div *ngIf="openModalFPassword">
  <app-modal-restablecer-contrasenia></app-modal-restablecer-contrasenia>
</div>
